// Fleet Reports — Unplugged Alerts section (P2, 2026-07-16).
// A "spotlight" on one rule (Tracker is unplugged!), split out of the behavior
// total so it is not double-counted. Big-number panel — green when zero (nobody
// tampered with a tracker this week), red otherwise — plus a per-vehicle row.
import React from "react";
import { Card } from "@mui/material";
import { RAG } from "./ragColors";

const sectionTitle = (text) => (
  <p style={{ fontSize: "15px", fontWeight: "bold", color: "#333333", margin: "0 0 12px 0", textTransform: "uppercase" }}>
    {text}
  </p>
);

export default function UnpluggedSection({ report }) {
  const m = (report && report.metrics && report.metrics.unplugged) || null;
  const vehicles = (report && report.vehicles) || [];
  if (!m) return null;

  const total = m.fleetWeek;
  const hasValue = total !== null && total !== undefined;
  const perVehicle = m.perVehicleWeek || [];
  const nameOf = (sensorId) => {
    const v = vehicles.find((x) => x.sensorId === sensorId);
    return (v && v.name) || `sensor ${sensorId}`;
  };

  // No matching active rule for this tenant → say so, don't show a fake 0.
  if (!hasValue) {
    return (
      <Card style={{ padding: "40px 20px", textAlign: "center" }}>
        <p style={{ fontSize: "15px", color: "#c7c7c7", margin: 0 }}>
          {m.note || "No tracker-unplugged rule is active for this fleet."}
        </p>
      </Card>
    );
  }

  return (
    <div>
      <Card style={{ padding: "24px", marginBottom: "20px", textAlign: "center" }}>
        {sectionTitle("Fleet total")}
        <div style={{ fontSize: "64px", fontWeight: "bold", lineHeight: 1.1, color: total === 0 ? RAG.good : RAG.bad }}>
          {total}
        </div>
        <p style={{ fontSize: "13px", color: "grey", margin: "6px 0 0 0" }}>
          {total === 0 ? "No tracker was unplugged in this period." : "Times a tracker was reported unplugged in this period."}
        </p>
      </Card>

      <Card style={{ padding: "16px" }}>
        {sectionTitle("Per vehicle")}
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
            <thead>
              <tr style={{ background: "#e2e2e2" }}>
                <th style={{ textAlign: "left", padding: "10px" }}>Vehicle</th>
                <th style={{ textAlign: "right", padding: "10px" }}>Unplugged events</th>
              </tr>
            </thead>
            <tbody>
              {perVehicle.map((r) => (
                <tr key={r.sensorId} style={{ borderBottom: "1px solid #eeeeee" }}>
                  <td style={{ padding: "10px", fontWeight: "bold" }}>{r.name || nameOf(r.sensorId)}</td>
                  <td style={{ padding: "10px", textAlign: "right", color: r.value === 0 ? "#333" : RAG.bad, fontWeight: r.value === 0 ? "normal" : "bold" }}>
                    {r.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
